import { motion } from "framer-motion";
import "./styles.css";
const About = () => {
  return (
    <motion.article
      initial={{ opacity: 0, transform: "translateY(10%)" }}
      animate={{ opacity: 1, transform: "translateY(0%)" }}
      eixt={{ opacity: 0 }}
      className="about"
    >
      <div className="container">
        <div className="about__container">
          <h4>
            <span>sauver des vies</span>
            <span className="dots">.......</span>
          </h4>
          <h5>Savez-vous quels sont les avantages du don de sang ?</h5>
          <div className="about__article">
            <p>
              Même après tant de progrès scientifiques, médicaux et
              technologiques, la formule permettant de fabriquer du sang en
              laboratoire n'a toujours pas été mise au point. Les dons sont
              nécessaires pour les personnes dans le besoin. Cependant,
              saviez-vous que les dons de sang sont bénéfiques non seulement
              pour les personnes dans le besoin mais aussi pour les donneurs ?
              Lisez la suite pour découvrir 7 avantages surprenants du don de
              sang que vous ne connaissez peut-être pas.
            </p>
            <p className="advantage">
              Le don de sang peut stimuler la production de nouvelles cellules
              sanguines, l'organisme s'efforçant de compenser les pertes de
              sang. Cela contribue à promouvoir une bonne santé.
            </p>
            <p className="advantage">
              Le don de sang à intervalles réguliers peut aider à prévenir
              l'hémochromatose.{" "}
            </p>
            <p className="advantage">
              Un niveau sain de fer dans l'organisme est également lié à un
              risque réduit de cancer.
            </p>
            <p className="advantage">
              L'organisme n'absorbe que la quantité de fer nécessaire et l'excès
              de fer est stocké dans le cœur, le foie et le pancréas.
            </p>
            <p className="advantage">
              Le don de sang peut contribuer à réduire le poids corporel.
            </p>
            <p className="advantage">
              Les dons de sang réguliers peuvent vous aider à contrôler votre
              état de santé.
            </p>
            <p className="advantage">
              En plus de votre santé physique, le don de sang est également
              bénéfique pour votre bien-être mental et émotionnel.
            </p>
          </div>
        </div>
      </div>
    </motion.article>
  );
};
export default About;
